import { z } from 'zod';

const imageCropDataSchema = z
  .object({
    x: z.number(),
    y: z.number(),
    zoom: z.number(),
  })
  .nullable()
  .optional();

export const schema = z.object({
  image: z.string().min(1, { message: 'required' }),
  image_original: z.string().optional(),
  image_crop_data: imageCropDataSchema,
});
